module.exports = __webpack_public_path__ + "static/media/developers1.b75ace5c.jpg";